import {STATE_PROP_NAME} from './profile-builder-constants'

export const getState = state => state[STATE_PROP_NAME]
